import { Formik } from "formik";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import ErrorMessage from "../../../form/ErrorMessage";
import { step3BootCampSchema } from "../../../../utils/schema";
import {
  clearBootCampFormData,
  getBootCampFormData,
} from "../../../../utils/pip";
import {
  addBootCamps,
  fetchBootcamps,
  updateBootcampImage,
  updateBootCamps,
} from "../../../../redux/features/admin/actions/authAction";

const CreateBootCampStep3 = ({
  step2DayData,
  onClose,
  previousForm,
  onHanldeSubmit,
  isEdit,
  bootcamp_id,
}) => {
  const savedData = getBootCampFormData().step3;
  const savedData2 = getBootCampFormData().step2;
  const savedData1 = getBootCampFormData().step1;

  const [bootCampPoints, setBootCampPoints] = useState(
    savedData?.points || [{ value: "" }]
  );
  const dispatch = useDispatch();
  const handleStep3 = (values) => {
    const hasEmptyPoint = bootCampPoints.some((point) => !point.value.trim());
    if (hasEmptyPoint) {
      toast.error("Please fill in all Bootcamp Points before continuing.");
      return;
    }
    const callback = (response) => {
      if (response?.success) {
        const callback2 = (res) => {
          if (res?.success) {
            dispatch(fetchBootcamps());
            clearBootCampFormData();
            onHanldeSubmit();
          }
        };

        if (isEdit) {
          const getSpeakerImageGroups = (dayData = []) => {
            const existingImageChangeSpeakers = [];
            const newSpeakersImages = [];

            dayData.forEach((day) => {
              (day.sessions || []).forEach((session) => {
                (session.speakers || []).forEach((sp) => {
                  if (sp.image && sp.image instanceof File) {
                    if (sp.session_speaker_id) {
                      existingImageChangeSpeakers.push({
                        session_speaker_id: sp.session_speaker_id,
                        image: sp.image,
                      });
                    } else {
                      newSpeakersImages.push({ image: sp.image });
                    }
                  }
                });
              });
            });

            return { existingImageChangeSpeakers, newSpeakersImages };
          };

          const { existingImageChangeSpeakers, newSpeakersImages } =
            getSpeakerImageGroups(step2DayData || []);
          // ✅ Check for image updates
          const hasHeaderFooterBrochure =
            values?.header_image instanceof File ||
            values?.footer_image instanceof File ||
            values?.brochure instanceof File;

          const hasSpeakerImageChanges =
            existingImageChangeSpeakers.length > 0 ||
            newSpeakersImages.length > 0;

          // --- CASE 1: No image changes at all ---
          if (!hasHeaderFooterBrochure && !hasSpeakerImageChanges) {
            clearBootCampFormData();
            onHanldeSubmit();
            return;
          }

          // --- CASE 2: Some image changes exist → upload them ---
          const allSpeakerImages = [
            ...existingImageChangeSpeakers,
            ...newSpeakersImages,
          ];

          const getAllSpeakerIds = (dayData) => {
            const ids = dayData.flatMap(
              (day) =>
                day.sessions?.flatMap((session) =>
                  session.speakers
                    ?.filter(
                      (sp) => sp?.is_new === true && sp.session_speaker_id
                    )
                    .map((sp) => sp.session_speaker_id)
                ) || []
            );
            return ids.filter(Boolean);
          };

          const allSpeakerIds = getAllSpeakerIds(
            response?.data?.program_days || []
          );
          const formData = new FormData();
          const existingIds = [];

          // Append speaker images and IDs
          allSpeakerImages.forEach((item) => {
            if (item.session_speaker_id) {
              existingIds.push(item.session_speaker_id);
            }
            formData.append("file", item.image);
          });
          const finalIds = [...new Set([...existingIds, ...allSpeakerIds])];
          if (values?.header_image?.name)
            formData.append("header_image", values.header_image);
          if (values?.footer_image?.name)
            formData.append("footer_image", values.footer_image);
          if (values?.brochure?.name)
            formData.append("brochure", values.brochure);
          if (finalIds?.length > 0) formData.append("ids", finalIds.join(","));

          dispatch(
            updateBootcampImage({
              payload: formData,
              callback: callback2,
              id: response?.data?.bootcamp_id,
            })
          );
        } else {
          const getAllSpeakerIds = (dayData) => {
            const ids = dayData.flatMap((day) =>
              day.sessions?.flatMap((session) =>
                session.speakers
                  ?.filter((sp) => sp.session_speaker_id)
                  .map((sp) => sp.session_speaker_id)
              )
            );

            return ids.filter(Boolean).join(","); // remove undefined/null, join by comma
          };

          const getAllSpeakerImages = (dayData) => {
            const images = dayData.flatMap((day) =>
              day.sessions?.flatMap((session) =>
                session.speakers?.filter((sp) => sp.image).map((sp) => sp.image)
              )
            );

            return images;
          };

          const allSpeakerIds = getAllSpeakerIds(
            response?.data?.program_days || []
          );
          const allSpeakerImages = getAllSpeakerImages(step2DayData || []);

          const formData = new FormData();
          formData.append("header_image", values?.header_image);
          formData.append("footer_image", values?.footer_image);
          formData.append("brochure", values?.brochure);
          allSpeakerImages?.forEach((element) => {
            formData.append("file", element);
          });
          formData.append("ids", allSpeakerIds);
          dispatch(
            updateBootcampImage({
              payload: formData,
              callback: callback2,
              id: response?.data?.bootcamp_id,
            })
          );
        }
      }
    };
    let data = {};
    if (isEdit) {
      data = {
        header_sub_title: savedData1?.header_sub_title || "",
        header_title: savedData1?.header_title || "",
        header_description: savedData1?.header_description || "",
        start_date: savedData1?.start_date || "",
        end_date: savedData1?.end_date || "",
        location: savedData1?.location || "",
        price: savedData2?.bootCampData?.bootcamp_price || "",
        seats: savedData2?.bootCampData?.bootcamp_seat || "",
        points: bootCampPoints?.map((item) => item?.value) || [],
        footer_title: values?.footer_title || "",
        footer_sub_title: values?.footer_sub_title || "",
        footer_description: values?.footer_description || "",
        program_days: savedData2?.dayData || [],
        footer_color: values?.footer_color ?? "#023047",
        brochure_color: values?.brochure_color ?? "#1e4457",
      };
      dispatch(
        updateBootCamps({ payload: data, callback, param: bootcamp_id })
      );
    } else {
      data = {
        header_sub_title: savedData1?.header_sub_title || "",
        header_title: savedData1?.header_title || "",
        header_description: savedData1?.header_description || "",
        start_date: savedData1?.start_date || "",
        end_date: savedData1?.end_date || "",
        location: savedData1?.location || "",
        price: savedData2?.bootCampData?.bootcamp_price || "",
        seats: savedData2?.bootCampData?.bootcamp_seat || "",
        points: bootCampPoints?.map((item) => item?.value) || [],
        footer_title: values?.footer_title || "",
        status: values?.status || "",
        footer_sub_title: values?.footer_sub_title || "",
        footer_description: values?.footer_description || "",
        program_days: savedData2?.dayData || [],
        footer_color: values?.footer_color ?? "#023047",
        brochure_color: values?.brochure_color ?? "#1e4457",
      };
      dispatch(addBootCamps({ payload: data, callback }));
    }
  };

  const addBootCampPoint = () => {
    setBootCampPoints((prev) => [...prev, { value: "" }]);
  };

  const deleteBootCampPoint = (index) => {
    setBootCampPoints((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChangePoint = (index, newValue) => {
    setBootCampPoints((prev) => {
      const updated = [...prev];
      updated[index].value = newValue;
      return updated;
    });
  };

  return (
    <div
      className="modal d-block modal-lg ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div className="modal-content ">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close ct_circle_close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body p-0">
            <h4 className="ct_fw_600 mb-1 ct_fs_20 ct_darksky_blue_text px-4">
              {isEdit ? "Update" : "Create"} your event step 3
            </h4>
            <p className="mb-0 ct_grey_text px-4">
              {isEdit ? "Update" : "Create"} and schedule {isEdit ? "" : "new"}{" "}
              events seamlessly.
            </p>
            <Formik
              initialValues={savedData}
              validationSchema={step3BootCampSchema}
              onSubmit={(values, actions) => {
                handleStep3(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldError,
                setTouched,
              }) => (
                <form className="mt-4 ct_modal_scroll ct_custom_scroll px-4">
                  <div className="row ">
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Sub Heading
                        </label>
                        <textarea
                          rows="2"
                          className="form-control ct_input h-auto"
                          placeholder="Bootcamp Sub Heading"
                          id="footer_title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.footer_title}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"footer_title"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Sub Title
                        </label>
                        <textarea
                          rows="2"
                          className="form-control ct_input h-auto"
                          placeholder="You’ll Get the Most Out of This If ?"
                          id="footer_sub_title"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.footer_sub_title}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"footer_sub_title"}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Sub Description
                        </label>
                        <textarea
                          className="form-control ct_input h-auto"
                          placeholder="a summary of the event purpose in 2000 characters"
                          id="footer_description"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.footer_description}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"footer_description"}
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group mb-4 ">
                        {bootCampPoints?.map((item, i) => (
                          <>
                            <div class="d-flex align-items-center justify-content-end gap-2 mb-2">
                              <div
                                class="ct_bootcamp_action_btn"
                                onClick={addBootCampPoint}
                                style={{ backgroundColor: "#ababab45" }}
                              >
                                <i class="fa-solid fa-plus"></i>
                              </div>
                              {i != 0 && (
                                <div
                                  class="ct_bootcamp_action_btn text-white"
                                  onClick={() => deleteBootCampPoint(i)}
                                  style={{ backgroundColor: "#ff0000" }}
                                >
                                  <i class="fa-solid fa-trash-can"></i>
                                </div>
                              )}
                            </div>
                            <textarea
                              rows={2}
                              className="form-control ct_input mb-2 h-auto"
                              placeholder="Bootcamp Points"
                              value={item?.value}
                              onChange={(e) =>
                                handleChangePoint(i, e.target.value)
                              }
                            />
                          </>
                        ))}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Brochure Color
                        </label>
                        <input
                          type="color"
                          id="brochure_color"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.brochure_color}
                          style={{
                            marginLeft: "10px",
                            width: "50px",
                            height: "40px",
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"brochure_color"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">
                          Bootcamp Footer Color
                        </label>
                        <input
                          type="color"
                          id="footer_color"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.footer_color}
                          style={{
                            marginLeft: "10px",
                            width: "50px",
                            height: "40px",
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"footer_color"}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Brochure Image</label>
                        <div class="ct_upload_product_main ct_upload_product_main_180 ">
                          <label>
                            <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                  fill="#023047"
                                />
                              </svg>
                              Upload Image
                            </p>
                            <input
                              type="file"
                              id="brochure"
                              accept="image/*"
                              onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                setTouched({ brochure: true });
                                setFieldValue("brochure", file);
                              }}
                              onBlur={handleBlur}
                              class="d-none"
                            />
                          </label>
                        </div>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"brochure"}
                        />
                        {values?.brochure && (
                          <div class="ct_single_uploaded_img mt-3 ">
                            <img
                              src={
                                values?.brochure
                                  ? typeof values.brochure === "string"
                                    ? values.brochure
                                    : URL.createObjectURL(values.brochure)
                                  : ""
                              }
                              alt=""
                            />
                            <i
                              class="fa-solid fa-xmark"
                              onClick={() => {
                                setTouched({ brochure: true });
                                setFieldValue("brochure", null);
                              }}
                            ></i>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Image</label>
                        <div class="ct_upload_product_main ct_upload_product_main_180 ">
                          <label>
                            <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                  fill="#023047"
                                />
                              </svg>
                              Upload Image
                            </p>
                            <input
                              type="file"
                              id="footer_image"
                              accept="image/*"
                              onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                setTouched({ footer_image: true });
                                setFieldValue("footer_image", file);
                              }}
                              onBlur={handleBlur}
                              class="d-none"
                            />
                          </label>
                        </div>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"footer_image"}
                        />
                        {values?.footer_image && (
                          <div class="ct_single_uploaded_img mt-3 ">
                            <img
                              src={
                                values?.footer_image
                                  ? typeof values.footer_image === "string"
                                    ? values.footer_image
                                    : URL.createObjectURL(values.footer_image)
                                  : ""
                              }
                              alt=""
                            />
                            <i
                              class="fa-solid fa-xmark"
                              onClick={() => {
                                setTouched({ footer_image: true });
                                setFieldValue("footer_image", null);
                              }}
                            ></i>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Bootcamp Image</label>
                        <div class="ct_upload_product_main ct_upload_product_main_180 ">
                          <label>
                            <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                  fill="#023047"
                                />
                              </svg>
                              Upload Bootcamp Image
                            </p>
                            <input
                              type="file"
                              id="header_image"
                              accept="image/*"
                              onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                setTouched({ header_image: true });
                                setFieldValue("header_image", file);
                              }}
                              onBlur={handleBlur}
                              class="d-none"
                            />
                          </label>
                        </div>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"header_image"}
                        />
                        {values?.header_image && (
                          <div class="ct_single_uploaded_img mt-3 ">
                            <img
                              src={
                                values?.header_image
                                  ? typeof values.header_image === "string"
                                    ? values.header_image
                                    : URL.createObjectURL(values.header_image)
                                  : ""
                              }
                              alt=""
                            />
                            <i
                              class="fa-solid fa-xmark"
                              onClick={() => {
                                setTouched({ header_image: true });
                                setFieldValue("header_image", null);
                              }}
                            ></i>
                          </div>
                        )}
                      </div>
                    </div>

                    {!isEdit && (
                      <div className="col-md-12">
                        <div className="form-group mb-4">
                          <label className="d-block mb-2">Saved As</label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select
                              className="form-control ct_input border-0 ct_fit_content"
                              onChange={(e) => {
                                setFieldValue("status", e.target.value);
                              }}
                              value={values?.status}
                            >
                              <option value={"Draft"}>Draft</option>
                              <option value={"Publish"}>Publish</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName={"status"}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-center pt-4">
                    <button
                      className="ct_yellow_btn ct_outline_grey px-5 py-2"
                      type="button"
                      onClick={previousForm}
                    >
                      Previous
                    </button>
                    {isEdit ? (
                      <button
                        className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                        type="button"
                        onClick={handleSubmit}
                      >
                        Update
                      </button>
                    ) : (
                      <button
                        className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                        type="button"
                        onClick={handleSubmit}
                      >
                        Continue
                      </button>
                    )}
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBootCampStep3;
